module.exports = __webpack_public_path__ + "static/media/kitty-eth.8d1602e9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/images/home-page/kitty-eth.svg
// module id = 127
// module chunks = 0